import { CommentItemKey } from 'common/Prose/components/TextInlineFormatBar/components/Buttons/CommentInlineFormatButton/CommentInlineFormatButton'
import { InlineFormatBarPluginKey } from 'common/Prose/Plugins/InlineFormatBarPlugin/InlineFormatBarPluginKey'
import { setMeta } from 'proseShared/utils/transactions'
import { Command } from '../types'

export const showCommentPrompt: Command = (state, dispatch) => {
  if (state.selection.empty) return false

  if (InlineFormatBarPluginKey.getState(state)?.formatBarVisible) {
    return setMeta(InlineFormatBarPluginKey, { runItemKey: CommentItemKey })(state, dispatch)
  }

  return false
}
